// Batch material catalogue shared by the Batcher console and batch detail popups.
export const MAT_META = {
  cement:        { label: "Cement (GP)",  unit: "kg",  color: "#71717A", bin: "silo" },
  sand:          { label: "Sand",         unit: "kg",  color: "#EAB308", bin: "agg" },
  man_dust:      { label: "Man Dust",     unit: "kg",  color: "#A16207", bin: "agg" },
  agg_7mm:       { label: "7 mm Agg",     unit: "kg",  color: "#0EA5E9", bin: "agg" },
  agg_10mm:      { label: "10 mm Agg",    unit: "kg",  color: "#0284C7", bin: "agg" },
  agg_14mm:      { label: "14 mm Agg",    unit: "kg",  color: "#0369A1", bin: "agg" },
  agg_20mm:      { label: "20 mm Agg",    unit: "kg",  color: "#075985", bin: "agg" },
  water:         { label: "Water",        unit: "L",   color: "#38BDF8", bin: "water" },
  wrda_pa:       { label: "WRDA PA",      unit: "ml",  color: "#F57C00", bin: "pump" },
  wrda_pn40:     { label: "WRDA PN40",    unit: "ml",  color: "#22c55e", bin: "pump" },
  aea:           { label: "AEA",          unit: "ml",  color: "#ef4444", bin: "pump" },
  daraset_nc90:  { label: "DARASET NC90", unit: "ml",  color: "#a855f7", bin: "pump" },
  accelerator:   { label: "Accelerator",  unit: "ml",  color: "#f97316", bin: "pump" },
  retarder:      { label: "Retarder",     unit: "ml",  color: "#14b8a6", bin: "pump" },
  superplasticiser: { label: "Superplasticiser", unit: "ml", color: "#ec4899", bin: "pump" },
};

// Resolve display meta for any batch material key, including dynamic exposed-rock
// keys ("exposed:{sku|name}") that aren't in the static catalogue above. Exposed
// decorative rocks weigh on the aggregate bin, so they inherit bin: "agg".
export function metaFor(key) {
  if (MAT_META[key]) return MAT_META[key];
  if (typeof key === "string" && key.startsWith("exposed:")) {
    return { label: key.slice(8).replace(/[-_]/g, " "), unit: "kg", color: "#D6A461", bin: "agg" };
  }
  return { label: String(key).replace(/_/g, " "), unit: "kg", color: "#71717A", bin: "agg" };
}
